<template>
  <div>
    <div v-if="$apollo.loading">
      <spinner />
    </div>
    <div v-else>
      <span v-if="status === 'SUCCESSFUL'">{{
        $t('paymentDone', 'The payment has already been made')
      }}</span>
      <span v-else>
        {{ $t('paymentCanceled') }}
      </span>
    </div>
  </div>
</template>

<script>
import Spinner from '../shared/spinner'
import { GET_EVENT_SETTINGS } from '../../graphql/event.graphql'
import { GET_ORDER } from '../../graphql/order.graphql'
import { updateOrder } from '../../http'

export default {
  name: 'canceled-payment',
  components: {
    Spinner,
  },
  props: {
    orderNumber: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      status: '',
    }
  },
  apollo: {
    getOrder: {
      query: GET_ORDER,
      variables() {
        return {
          orderId: this.orderNumber,
        }
      },
      async result({ loading, data }) {
        if (!loading) {
          const {
            getOrder: { eventId, status },
          } = data
          this.status = status
          const {
            data: {
              getEvent: { slug },
            },
          } = await this.$apollo.query({
            query: GET_EVENT_SETTINGS,
            variables: {
              id: eventId,
            },
          })
          await updateOrder(this.orderNumber, { status: 'FAILED' })
          if (status !== 'SUCCESSFUL') {
            setTimeout(() => {
              this.goTo(this.routes.shared.register, {
                eventSlug: slug,
                orderNumber: this.orderNumber,
                status: 'FAILED',
              })
            }, 5000)
          }
        }
      },
    },
  },
}
</script>

<style scoped></style>
